import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';

import type { IconName } from '../../common/icon/icons.type';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-product-selectable-card',
  templateUrl: './product-selectable-card.component.html',
  styleUrls: ['./product-selectable-card.component.less'],
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.active]': 'isActive()',
  },
})
export class ProductSelectableCardComponent {
  public readonly isActive = input<boolean>(false);
  public readonly iconName = input<IconName>(undefined!);
  public readonly productName = input<string>(undefined!);
  public readonly text = input<string>(undefined!);
  @Input() public productType: string;
}
